
import Vue from "vue";
import { Component } from "vue-property-decorator";
import StandardButton from "@/components/UI/StandardButton.vue";
import { toggleUiPanel } from "@/lib/panels/panels";

@Component({ components: { StandardButton } })
export default class BlankSidebarContent extends Vue {
  toggleAdd() {
    toggleUiPanel("add");
  }
}
